"use client";

import {
  ActivityIcon,
  SettingsIcon,
  UsersIcon,
  ListIcon,
  AwardIcon,
  ReceiptTextIcon,
} from "lucide-react";
import { TabsCard } from "@/components/backoffice/tabs-card";
import { AdministrationConfigurableLists } from "@/components/backoffice/system/administration-configurable-lists";
import { AdministrationActivity } from "@/components/backoffice/system/administration-activity";
import { AdministrationAak } from "@/components/backoffice/system/aak";
import { AdministrationColorRules } from "@/components/backoffice/system/color-rules/administration-color-rules";
import { AdministrationFacturationRules } from "@/components/backoffice/system/facturation-rules";

const tabs = [
  {
    name: "Natures de vente",
    value: "aak",
    icon: ListIcon,
    content: <AdministrationAak />,
  },
  {
    name: "Listes",
    value: "configurable-lists",
    icon: SettingsIcon,
    content: <AdministrationConfigurableLists />,
  },
  {
    name: "Gestion des Utilisateurs",
    value: "users",
    icon: UsersIcon,
    content: "WIP",
  },
  {
    name: "Couleur / Nuance",
    value: "color-rules",
    icon: AwardIcon,
    content: <AdministrationColorRules />,
  },
  {
    name: "Facturation opérations",
    value: "facturation-rules",
    icon: ReceiptTextIcon,
    content: <AdministrationFacturationRules />,
  },
  {
    name: "Logs d'activité",
    value: "logs",
    icon: ActivityIcon,
    content: <AdministrationActivity />,
  },
];

function AdministrationTabsCard() {
  return <TabsCard tabs={tabs} />;
}

export { AdministrationTabsCard };
